import { useState } from "react";
import { getAuthParams } from "../../../../utils/pacto-rebates-utils";
import { formatLatePaymentPenaltyResponse } from "../../../utils/late-payment-penalty-utils";
import { buildParams } from "../../../utils/admin-utils";
import { throwResponseError } from "../../../../utils/api-error-utils";

export function useLatePaymentPenalties() {
    const [latePaymentPenalties, setLatePaymentPenalties] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    async function fetchLatePaymentPenalties(pagination = {}) {
        try {
            setLoading(true);
            setError(null);

            const {
                accessToken,
                clientId
            } = getAuthParams();

            const params = buildParams(pagination);

            const requestOptions = {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "access_token": accessToken,
                    "client_id": clientId
                }
            };

            const response = await fetch(
                process.env.REACT_APP_ESSILOR_API +
                    `pacto-rebates-admin/v1/penalidades-inadimplencia?${params.toString()}`,
                requestOptions
                
            );

            if (!response.ok) {
                await throwResponseError(response, "Erro ao buscar penalidade por inadimplência");
            }

            const data = await response.json();
            const latePaymentPenaltiesData = data.resultado || [];

            const responsePagination = {
                totalElements: data.totalElementos ?? 0,
                totalPages: data.totalPaginas ?? 0,
                page: data.pagina ?? 0,
                size: data.tamanho ?? pagination.size ?? 10
            };

            const formattedLatePaymentPenalties = Array.isArray(latePaymentPenaltiesData)
                ? latePaymentPenaltiesData.map(formatLatePaymentPenaltyResponse)
                : [];

            setLatePaymentPenalties(formattedLatePaymentPenalties);

            return {
                ok: true,
                empty: formattedLatePaymentPenalties.length === 0,
                latePaymentPenalties: formattedLatePaymentPenalties,
                pagination: responsePagination
            };
        } catch (requestError) {
            setLatePaymentPenalties([]);
            setError(requestError.message);

            return {
                ok: false,
                reason: "request",
                error: requestError.message
            };
        } finally {
            setLoading(false);
        }
    }

    return {
        latePaymentPenalties,
        loading,
        error,
        refetch: fetchLatePaymentPenalties
    };
}